import { render, staticRenderFns } from "./IncorrectAuthenticationDataError.vue?vue&type=template&id=5084451c&scoped=true&"
import script from "./IncorrectAuthenticationDataError.vue?vue&type=script&lang=ts&"
export * from "./IncorrectAuthenticationDataError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5084451c",
  null
  
)

export default component.exports